import styled, { css } from "styled-components";

export const Container = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
    margin: 1.5rem 0;

    @media (max-width: 425px){
        gap: 0.5rem;
    }
`

export const RadioButton = styled.div`
    border: 1px solid var(--colorFontsCardsDashboard);
    padding: 0.5rem 0.2rem;
    color: var(--colorFontsCardsDashboard);
    border-radius: 5px;
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;

    span{
        position: absolute;
        top: 2.5px;
        right: 2.5px;
        font-size: 0.7rem;
    }

    ${props => props.active && css`
        background: #7A05A7;
        border: none;
        color: #FFF;
    `}

    @media (min-width: 960px){
        cursor: pointer;
    }
`